module.exports = __webpack_public_path__ + "sa.d3a0ad4df60342394b50.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sa.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sa.svg
// module chunks = styles